var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrategize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.07 47.9901C35.8112 47.9901 46.14 37.6613 46.14 24.9201C46.14 12.1789 35.8112 1.8501 23.07 1.8501C10.3288 1.8501 0 12.1789 0 24.9201C0 37.6613 10.3288 47.9901 23.07 47.9901Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 25.9902C28.3797 20.3602 35.5497 14.4102 40.0897 9.9902C42.4597 7.6802 44.6497 5.1902 46.8397 2.7002",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 1.08008C43.4199 3.41008 42.6999 7.00008 43.1099 6.89008C45.1099 6.35008 47.0199 6.33008 49.0199 5.79008",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5404 3.99023C40.2104 6.14023 40.0804 9.78023 40.5404 9.80023C42.4257 9.90174 44.3151 9.90174 46.2004 9.80023",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 22.27C23.6997 24.48 23.9497 24.27 23.1797 26.22C24.5697 25.87 24.7497 25.41 27.3397 25.27",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5603 19.3501C34.6001 21.018 35.1253 22.9554 35.0703 24.9201C35.026 28.0833 33.7457 31.1037 31.5031 33.3351C29.2605 35.5664 26.2338 36.8317 23.0703 36.8601C16.7903 36.8601 11.0703 30.7601 11.0703 24.4701C11.0703 18.1801 16.7803 12.8301 23.0703 12.8301C25.7937 12.8765 28.4151 13.8741 30.4803 15.6501",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5302 15.4698C37.9464 16.0412 38.3016 16.6545 38.5902 17.2998C42.5302 25.4098 38.9402 37.4198 30.8302 41.3598C22.1702 45.5798 10.8202 40.7298 6.88015 32.5798C2.94015 24.4298 7.00015 12.1398 15.2002 8.47983C22.7802 5.10984 28.6201 6.78983 33.8501 11.4798",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4502 23.8199C30.3402 28.9699 26.8102 31.0299 23.0802 31.0299C21.4418 30.926 19.9013 30.2144 18.7601 29.0343C17.6189 27.8543 16.9592 26.2908 16.9102 24.6499C16.9741 23.0498 17.6498 21.5352 18.7979 20.4187C19.946 19.3023 21.4788 18.6691 23.0802 18.6499C24.2041 18.6758 25.2971 19.0228 26.2302 19.6499",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5,
    height: 47.42,
    fill: "white",
    transform: "translate(0 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrategize);
export default __webpack_public_path__ + "static/media/icon-strategize.03a1022ca10120b4f7800c529ce6a0e4.svg";
export { ForwardRef as ReactComponent };